import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import { compute } from 'compute-scroll-into-view';
import { ScrollControls } from '../scroll-controls/Component.js';
import 'tslib';
import 'lodash/debounce';
import '../../../../icon-button/esm';
import '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import '../scroll-controls/utils.js';

var styles = {"scrollableContainerWrapper":"tabs__scrollableContainerWrapper_smi0t","container":"tabs__container_smi0t","fullWidthScroll":"tabs__fullWidthScroll_smi0t"};
require('./index.css');

/**
 * Дополнительная прокрутка при клике на не поместившийся таб
 */
var ADDITIONAL_SCROLL_LEFT_VALUE = 50;
var isOverflown = function (_a, controlsNode) {
    var clientWidth = _a.clientWidth, scrollWidth = _a.scrollWidth;
    var controlsWidth = (controlsNode === null || controlsNode === void 0 ? void 0 : controlsNode.offsetWidth) || 0;
    return scrollWidth > clientWidth + controlsWidth;
};
var ScrollableContainer = function (_a) {
    var _b;
    var containerWrapperClassName = _a.containerWrapperClassName, containerClassName = _a.containerClassName, scrollControlsClassName = _a.scrollControlsClassName, children = _a.children, activeChild = _a.activeChild, fullWidthScroll = _a.fullWidthScroll, view = _a.view, size = _a.size, platform = _a.platform, inlineStyle = _a.inlineStyle, showSkeleton = _a.showSkeleton;
    var containerRef = useRef(null);
    var controlsRef = useRef(null);
    var _c = useState(false), overflown = _c[0], setOverflown = _c[1];
    useEffect(function () {
        if (activeChild) {
            var actions = compute(activeChild, {
                scrollMode: 'if-needed',
                block: 'nearest',
                inline: 'nearest',
                boundary: function (parent) { return !parent.isSameNode(containerRef.current); },
            });
            // TODO: animate?
            actions.forEach(function (_a) {
                var el = _a.el, left = _a.left;
                // eslint-disable-next-line no-param-reassign
                el.scrollLeft =
                    el.scrollLeft > left
                        ? left - ADDITIONAL_SCROLL_LEFT_VALUE
                        : left + ADDITIONAL_SCROLL_LEFT_VALUE;
            });
        }
    }, [activeChild]);
    useEffect(function () {
        var scrollableNode = containerRef.current;
        var tabsContainer = scrollableNode === null || scrollableNode === void 0 ? void 0 : scrollableNode.firstElementChild;
        if (platform === 'desktop' && scrollableNode && tabsContainer && window.ResizeObserver) {
            var observerCb = function () {
                if (isOverflown(scrollableNode, controlsRef.current)) {
                    setOverflown(true);
                }
                else {
                    setOverflown(false);
                }
            };
            var observer_1 = new ResizeObserver(observerCb);
            observer_1.observe(scrollableNode);
            observer_1.observe(tabsContainer);
            return function () { return observer_1.disconnect(); };
        }
        return function () { };
    }, [platform]);
    return (React.createElement("div", { className: cn(styles.scrollableContainerWrapper, containerWrapperClassName), style: inlineStyle },
        React.createElement("div", { ref: containerRef, className: cn(styles.container, containerClassName, (_b = {},
                _b[styles.fullWidthScroll] = fullWidthScroll,
                _b)) }, children),
        overflown && platform === 'desktop' ? (React.createElement(ScrollControls, { className: scrollControlsClassName, ref: controlsRef, containerRef: containerRef, view: view, size: size, showSkeleton: showSkeleton })) : null));
};

export { ScrollableContainer };
